const attachOneTrust = () => {
  if (window.troveGlobal.oneTrustTargetLink) {
    const link = document.querySelector(window.troveGlobal.oneTrustTargetLink);

    if (link) {
      link.setAttribute('href', '#showPrivacyCenter');
      link.setAttribute('class', link.getAttribute('class') + ' ot-sdk-show-settings');
      link.setAttribute('id', 'ot-sdk-btn');
    
      const script = document.createElement('script');
      script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      script.defer = 'defer';
      script.setAttribute('data-domain-script', window.troveGlobal.oneTrustDataDomainCode);
      script['data-document-language'] = 'true';
      document.head.appendChild(script);
    }
  }
}

attachOneTrust();

function OptanonWrapper () { }

